import axios from 'axios';
import type { AuditResponseInterface } from '../types/Audit';
import { constructQueryParamsUrl } from '../utils';
import { baseUrl, HttpMethods } from './base';

export interface IGetAddressDecodeResData {
  formatted_address: string;
  address_components: {
    long_name: string;
    short_name: string;
    types: string[];
  }[];
  place_id: string;
  lat: number;
  lng: number;
  url: string;
}

export async function getAddressDecode(address: string) {
  const res = await axios.get<{
    data: IGetAddressDecodeResData;
    message: string;
  }>(`${baseUrl.SHERPA}/ext/maps/decode?address=${address}`);
  return res.data;
}

const uploadAxios = axios.create({
  withCredentials: false,
});

interface IUploadSignedAsset<T = File> {
  url: string;
  file: T;
  assetType?: string;
}
export const uploadSignedAsset = async ({ url, file }: IUploadSignedAsset) => {
  const res = await uploadAxios.put(url, file, {
    headers: {
      'Content-Type': file.type,
      'Content-Disposition': `attachment;filename="${file.name}"`,
    },
  });
  return res.data;
};

// Generated by https://quicktype.io

export interface AuditServiceResponse {
  data: AuditResponseInterface[];
}

interface AuditParamsInterface {
  params: {
    resource_type?: string;
    resource_id?: number;
    users?: number;
  };
}

export async function getAuditEntries({ params }: Partial<AuditParamsInterface>) {
  const urlParams = constructQueryParamsUrl(params);
  const res = await axios.request<AuditServiceResponse>({
    method: HttpMethods.GET,
    url: `${baseUrl.SHERPA}/audits${urlParams}`,
  });
  return res.data;
}

// Generated by https://quicktype.io

export interface NotificationsInterface {
  alerts: NotificationInterface[];
  count: Count;
}

export interface NotificationInterface {
  id: number;
  content: string;
  read: boolean;
  createdAt: string;
  target: NotificationTargetInterface;
}

export interface NotificationTargetInterface {
  id: number;
  resource: string;
}

export interface Count {
  unread: number;
}

export async function getOldNotifications({ perPage }: { perPage: number }) {
  const res = await axios({
    method: HttpMethods.GET,
    url: `${baseUrl.SHERPA}/alerts?page=1&perPage=${perPage}`,
  });
  return res.data;
}

export async function markReadNotification(notificationId: number) {
  await axios({
    method: HttpMethods.PATCH,
    url: `${baseUrl.SHERPA}/alerts/${notificationId}/read`,
  });
}
